import React from 'react';
import PropTypes from 'prop-types';
import TreeFacet from './TreeFacet';
import styles from './TreeFacetList.module.less';
import clsx from 'clsx';

const TreeFacetList = ({
  facetsArray = [],
  onClick,
  topLevel = false,
  group,
}) => (
  <ul className={clsx(styles.facets, topLevel && styles.topLevel)}>
    {facetsArray.map(facet => (
      <TreeFacet
        key={facet.urlName}
        displayName={facet.display}
        internalName={facet.internalName}
        urlName={facet.urlName}
        href={facet.href}
        disabled={facet.disabled}
        selected={facet.selected}
        nestedTags={facet.children}
        onClick={onClick}
        hasChildren={facet.hasChildren}
        group={group}
      />
    ))}
  </ul>
);

export default TreeFacetList;

TreeFacetList.propTypes = {
  facetsArray: PropTypes.array,
  onClick: PropTypes.func,
  topLevel: PropTypes.bool,
  group: PropTypes.string,
};
